import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {WingedSheepComponent} from './winged-sheep/winged-sheep.component';

export type SpotKind = 'stitch' | 'feather' | 'sheep';

/**
 * A small decorative drawing above a page title, one per page so no picture repeats:
 * a needle and thread (Features), a quill feather and a coin (Pricing), a winged sheep (About).
 */
@Component({
  selector: 'app-spot',
  templateUrl: './spot.component.html',
  styleUrls: ['./spot.component.scss'],
  imports: [WingedSheepComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotComponent {
  @Input({required: true}) kind!: SpotKind;
}
